import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useAudio } from '../context/AudioManagementContext';

const Checkbox = ({ checked, toggle }) => {
  const { playClick, playHover } = useAudio();
  const [wait, setWait] = useState(false);
  const clickTimeout = useRef(null);

  const debounceClick = (event, value) => {
    if (event) {
      if (event.stopPropagation) event.stopPropagation();
      if (event.cancelable && !event.isDefaultPrevented())
        event.preventDefault();
    }
    if (wait) return;
    setWait(true);

    playClick(0.5, () => {
      toggle(value);
    });

    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current);
    }

    clickTimeout.current = setTimeout(() => {
      setWait(false);
    }, 300);
  };

  const onHover = () => {
    playHover(0.2);
  };

  return (
    <div className="checkbox-container">
      <div
        className="checkbox-wrapper pixel-corners-wrapper"
        onClick={(event) => debounceClick(event, true)}
        onTouchStart={(event) => debounceClick(event, true)}
        onMouseEnter={onHover}
      >
        <div className={`pixel-corners checkbox yes ${checked && 'checked'}`}>
          YES
        </div>
      </div>
      <div
        className="checkbox-wrapper pixel-corners-wrapper"
        onClick={(event) => debounceClick(event, false)}
        onTouchStart={(event) => debounceClick(event, false)}
        onMouseEnter={onHover}
      >
        <div
          className={`pixel-corners checkbox no ${checked !== undefined && !checked && 'checked'}`}
        >
          NO
        </div>
      </div>
    </div>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  toggle: PropTypes.func
};

export default Checkbox;
